export default class woocommerceCustomjs {
    init() {
        // On lance la gestion des notifications au démarrage
        this.setupNotificationClose();
        this.setupAutoRemove();
    }

    /**
     * Ajoute un écouteur de clic pour fermer la notification manuellement
     */
    setupNotificationClose() {
        console.log("setupNotificationClose ready");
        // Délègue l'événement au document pour être sûr que ça marche même si le HTML est chargé dynamiquement
        $(document).on('click', '.woocommerce-notices-wrapper', function (e) {
            // Optionnel : Ne fermer que si on clique sur une petite croix (à ajouter en CSS/HTML) 
            // ou fermer partout comme ici :
            $(this).slideUp(300, function () {
                $(this).remove();
            });
        });
    }

    /**
     * Fait disparaître la notification automatiquement après 5 secondes
     */
    setupAutoRemove() {
        console.log("setupAutoRemove ready");

        setTimeout(() => {
            const $notices = $('.woocommerce-notices-wrapper');

            $notices.fadeOut(500, function () {
                $(this).remove();
            });
        }, 5000); // 5000ms = 5 secondes
    }
}